export function placementContextHandler(wsRef, realtimeContext) {
  var _a, _b;
  const {
    requestFrom
  } = realtimeContext;
  switch (requestFrom) {
    case 'travel-itinerary':
      const {
        offerToken,
        offerNumber,
        cguid,
        rguid
      } = realtimeContext !== null && realtimeContext !== void 0 ? realtimeContext : {};
      wsRef.current.sendMessage({
        type: 'realtime_client_context',
        data: {
          offerNumber,
          offerToken,
          requestFrom,
          cguid,
          rguid
        }
      });
      break;
    case 'hotelListingPage':
    case 'productListingPage':
      const {
        listingContext
      } = realtimeContext !== null && realtimeContext !== void 0 ? realtimeContext : {};
      if ((_b = (_a = listingContext === null || listingContext === void 0 ? void 0 : listingContext.hotelPayload) === null || _a === void 0 ? void 0 : _a.availableHotelsOnListing) === null || _b === void 0 ? void 0 : _b.length) {
        wsRef.current.sendMessage({
          type: 'realtime_client_context',
          data: {
            listingContext,
            requestFrom
          }
        });
      }
      break;
    case 'hotelDetailPage':
    case 'productDetailPage':
      const {
        detailsContext,
        hotelName
      } = realtimeContext !== null && realtimeContext !== void 0 ? realtimeContext : {};
      if (detailsContext) {
        wsRef.current.sendMessage({
          type: 'realtime_client_context',
          data: {
            detailsContext,
            requestFrom,
            hotelName
          }
        });
      }
      break;
    case 'rcListingsPage':
      const {
        rcListingsContextStr
      } = realtimeContext !== null && realtimeContext !== void 0 ? realtimeContext : {};
      if (rcListingsContextStr) {
        wsRef.current.sendMessage({
          type: 'realtime_client_context',
          data: {
            rcListingsContextStr,
            requestFrom
          }
        });
      }
      break;
    default:
      break;
  }
}